import { render, staticRenderFns } from "./WalletCardProductSelect.vue?vue&type=template&id=14654a2f&scoped=true&"
import script from "./WalletCardProductSelect.vue?vue&type=script&lang=js&"
export * from "./WalletCardProductSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14654a2f",
  null
  
)

export default component.exports